import React from "react";

import Experience from "../Experience";
import Landing from "../Landing";
import MyStory from "../MyStory";
import NavBar from "../NavBar";
import Portfolio from "../Portfolio";
import SocialLinks from "../SocialLinks";

import YearOfArchive from "../YearOfArchive";

const Home = () => {
  return (
    <div>
      <NavBar />
      <Landing />
      <SocialLinks />
      <MyStory />
      <Portfolio />
      <Experience />
      <YearOfArchive />
    </div>
  );
};

export default Home;
